import React, { useEffect } from 'react';
import { useSlotPlaceholder, withSlotsPlaceholders } from '@wix/widget-plugins-ooi';
import BlogPushNotifications from '../../../common/components/blog-push-notifications';
import { FastFormProvider } from '../../../common/components/fast-form';
import { getFastFormSubmitAction } from '../../../common/components/fast-form/store/fast-form-selectors';
import PermissionsProvider from '../../../common/components/permissions-provider';
import ResponsiveListener from '../../../common/components/responsive-listener/responsive-listener';
import { withRootProps } from '../../../common/components/root-props/with-root-props';
import { useSelector } from '../../../common/components/runtime-context';
import { withReduxStore } from '../../../common/components/runtime-context/with-redux-store';
import WindowResizeListener from '../../../common/components/window-resize-listener';
import { useI18n } from '../../../common/hooks/use-i18n';
import {
  getPinterestEnabled,
  getIsCreatedWithResponsiveEditor,
} from '../../../common/selectors/app-settings-selectors';
import pinterest from '../../../common/services/pinterest';
import {
  getLanguage,
  isSeo as getIsSeo,
  getIsMobile,
  isEditor as getIsEditor,
} from '../../../common/store/basic-params/basic-params-selectors';
import PostPushNotifications from '../../components/post-push-notifications';
import Router from '../router';
import styles from './app-root.scss';
import { ABOVE_HEADER } from '../../../../constants/ooi-slots';

function AppRoot() {
  const {
    language,
    isMobile,
    isPinterestEnabled,
    addResizeListener,
    submitAction,
  } = useSlice();
  const [AboveHeaderSlotsPlaceholder, isAboveHeaderSlotEmpty] =
    useSlotPlaceholder(ABOVE_HEADER);

  useI18n();

  useEffect(() => {
    pinterest.init({ language, isMobile, isPinterestEnabled });

    return () => {
      pinterest.removeEventListener();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ResponsiveListener dataHook="post-page-root" className={styles.root}>
      <PermissionsProvider>
        <FastFormProvider submitAction={submitAction}>
          <>
            <div className={!isAboveHeaderSlotEmpty ? styles.aboveHeaderSlot : ''}>
              <AboveHeaderSlotsPlaceholder />
            </div>
            <Router />
            {addResizeListener && <WindowResizeListener />}
            <BlogPushNotifications />
            <PostPushNotifications />
          </>
        </FastFormProvider>
      </PermissionsProvider>
    </ResponsiveListener>
  );
}

function useSlice() {
  const language = useSelector(getLanguage);
  const isMobile = useSelector(getIsMobile);
  const isPinterestEnabled = useSelector(getPinterestEnabled);
  const submitAction = useSelector(getFastFormSubmitAction);
  const isSeo = useSelector(getIsSeo);

  const isInClassicEditor = useSelector(
    (state) => getIsEditor(state) && !getIsCreatedWithResponsiveEditor(state),
  );

  return {
    language,
    isSeo,
    isMobile,
    isPinterestEnabled,
    submitAction,
    addResizeListener: isInClassicEditor,
  };
}

export default withSlotsPlaceholders(withRootProps(withReduxStore(AppRoot)));
